import React, { Suspense, lazy } from "react"

import Link from "~components/Link"

import logo from "~images/boxdev.svg"
import { Bell } from "~components/Changelog"
import * as style from "./Header.module.scss"

import Menu from "./Menu"
import ConsoleButton from "./ConsoleButton"
import InternationalSiteButton from "./InternationalSiteButton"
import Sidebar from "./Sidebar"

const SearchBar = lazy(() => import("./SearchBar"))

const Header = ({ microcopy, searchEnabled }) => (
  <>
    <div className={style.header}>
      <div className={style.wrapper}>
        <section>
          <Sidebar microcopy={microcopy} />
          <Link to="/" microcopy={microcopy} className={style.logo}>
            <img src={logo} alt={microcopy.text("head.title")} />
          </Link>
          <InternationalSiteButton />
        </section>

        <Menu microcopy={microcopy} />

        <section className={style.rightColumn}>
          {process.env.GATSBY_FEATURE_CHANGELOG === "true" && (
            <Bell microcopy={microcopy} />
          )}

          <ConsoleButton microcopy={microcopy} />

          {searchEnabled && (
            <Suspense fallback={<div />}>
              <SearchBar microcopy={microcopy} />
            </Suspense>
          )}
        </section>
      </div>
    </div>
  </>
)

export default Header
